const FixationSvg = () => {
  return(
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none"><path fill="#A7C9F0" d="M6.549.38a1.306 1.306 0 0 1 1.843 0l3.226 3.228A1.304 1.304 0 0 1 9.775 5.45l-.23-.23L7.62 7.145c.58 1.571.192 3.51-1.072 4.76a.328.328 0 0 1-.461 0L3.323 9.14l-2.074 2.075a.326.326 0 1 1-.46-.461l2.073-2.075L.097 5.912a.323.323 0 0 1 0-.46C1.33 4.217 3.203 3.776 4.855 4.378L6.78 2.455l-.23-.23a1.305 1.305 0 0 1 0-1.844Z"/></svg>
  )
}

export default FixationSvg;